import { render, staticRenderFns } from "./IconDragUpDown.vue?vue&type=template&id=2339bf9f&"
import script from "./IconDragUpDown.vue?vue&type=script&lang=js&"
export * from "./IconDragUpDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports